import PropTypes from 'prop-types'
import { useEffect, useMemo, useState } from 'react'
import { FormLabel, Modal } from 'react-bootstrap'
import invoiceApi from 'api/invoiceApi'
import { setAppSpinning } from 'app/appSlice'
import CustomSelect from 'general/components/CustomSelect'
import Option from 'general/components/CustomSelect/CustomOption'
import MenuList from 'general/components/CustomSelect/MenuList'
import ToastHelper from 'general/helpers/ToastHelper'
import { useDispatch } from 'react-redux'
import './style.scss'
import ExcelJs from 'exceljs'
import {
  ALPHABET_CHARACTERS,
  INVOICE_UPLOAD_DATA_MULTIPLE_TAX_RATE_SAMPLES,
  INVOICE_UPLOAD_DATA_SINGLE_TAX_RATE_SAMPLES,
  INVOICE_UPLOAD_GUIDES,
  INVOICE_UPLOAD_HEADER_COLUMNS,
  TYPE_INVOICE_EXCEL,
} from 'general/constants/AppConstants'
import { filterColumnsBaseOnInvoiceTemplate } from 'general/helpers/ImportInvoiceHelper'
import { useAppSelector } from 'hooks/useRedux'
import Utils from 'general/utils/Utils'
import ModalValidateUploadInvoiceExcel from '../ModalTableInputFile'
import { truncate } from 'lodash'
import SelectOptions from 'general/constants/SelectOptions'

ModalUploadInvoiceExcel.prototype = {
  show: PropTypes.bool,
  setShow: PropTypes.func,
  content: PropTypes.string,
  handleConfirm: PropTypes.func,
  serials: PropTypes.array,
}

function ModalUploadInvoiceExcel(props) {
  const dispatch = useDispatch()

  const { show, setShow, serials } = props

  const templateInvoiceSerials = useMemo(
    () => serials?.filter(({ value }) => value) || [],
    [serials],
  )

  const [selectedInvoiceTemplate, setSelectedInvoiceTemplate] = useState()
  const [selectedFile, setSelectedFile] = useState()
  const [resultText, setResultText] = useState('')
  const [validateFile, setValidateFile] = useState({ show: false })
  const { formatNumber } = useAppSelector((state) => state?.systemConfig)

  useEffect(() => {
    if (!templateInvoiceSerials?.length) return

    let firstInvoiceTemplate = templateInvoiceSerials.at(0)
    setSelectedInvoiceTemplate({
      invoiceTemplateId: firstInvoiceTemplate.invoiceTemplateId,
      label: firstInvoiceTemplate.serial,
      value: firstInvoiceTemplate.invoiceTemplateId,
      name: firstInvoiceTemplate.name,
      category: firstInvoiceTemplate.category,
      extend_fields: firstInvoiceTemplate.extend_fields,
      isDeliveryInvoice: firstInvoiceTemplate.isDeliveryInvoice,
    })
  }, [templateInvoiceSerials])

  const handleClose = () => {
    setShow(false)
    setResultText('')
    setSelectedInvoiceTemplate()
    setSelectedFile()
  }

  const handleSelectInvoiceSerial = (invoiceTemplate) => {
    setSelectedInvoiceTemplate(invoiceTemplate)
  }

  const handleUploadExcel = async ({ notValidate }) => {
    if (!selectedFile) {
      ToastHelper.showError('Chưa chọn file excel')
      return
    }

    if (!selectedInvoiceTemplate) {
      ToastHelper.showError('Chưa chọn mẫu hóa đơn')
      return
    }
    if (!notValidate) {
      handleFile(selectedFile)
      return
    } else {
      let params = {
        invoiceTemplateId: selectedInvoiceTemplate.invoiceTemplateId,
        file: selectedFile,
      }
      dispatch(setAppSpinning(true))
      try {
        let res = await invoiceApi.upload(params)
        dispatch(setAppSpinning(false))
        let { successInvoiceSequences, failedInvoiceSequences } = res
        successInvoiceSequences = successInvoiceSequences.map((item) => ({
          ...item,
          success: 'Y',
        }))
        failedInvoiceSequences = failedInvoiceSequences.map((item) => ({
          ...item,
          success: 'N',
        }))
        let combineResult = successInvoiceSequences
          .concat(failedInvoiceSequences)
          .sort((a, b) => a.invoiceSequence - b.invoiceSequence)
        // .map((item) => {
        //   let { index, ...rest } = item
        //   return rest
        // })
        ToastHelper.showSuccess('Upload excel hóa đơn thành công')
        setResultText(
          combineResult.map((item) => JSON.stringify(item)).join(',<br/>'),
        )
      } catch (e) {
        console.log(e)
        setResultText('')
        dispatch(setAppSpinning(false))
      } finally {
        if (typeof props?.refetchListInvoice == 'function') {
          props.refetchListInvoice()
        }
      }
    }
  }

  const columnNumberToName = (num) => {
    let name = ''
    while (num > 0) {
      let rem = (num - 1) % 26
      name = String.fromCharCode(65 + rem) + name
      num = Math.floor((num - 1) / 26)
    }
    return name
  }

  const getCellValue = (cell) => {
    if (!cell) return null

    const v = cell.value
    if (!v) return null

    if (v.formula) return v.result
    if (v.text) return v.text
    return v
  }

  const getCellByColumnName = (row, columnIndex, formatNumber, type) => {
    try {
      if (type == 'number') {
        let result
        const cell = row.getCell(columnIndex)
        switch (cell.type) {
          case ExcelJs.ValueType.Formula:
            let value = cell.value.result ?? null
            if (formatNumber == null) {
              if (typeof value === 'number') {
                result = value
              } else {
                result = Number(
                  value
                    ?.toString()
                    ?.trim()
                    ?.replaceAll('.', '')
                    ?.replace(',', '.'),
                )
              }
            } else {
              if (typeof value === 'number') {
                result = Utils.roundNumber(Number(value), formatNumber)
              } else {
                result = Utils.roundNumber(
                  Number(
                    value
                      ?.toString()
                      ?.trim()
                      ?.replaceAll('.', '')
                      ?.replace(',', '.'),
                  ),
                  formatNumber,
                )
              }
            }
            if (Number.isNaN(result)) {
              result = 0
            }
            return result
          default:
            if (formatNumber == null) {
              if (typeof row.getCell(columnIndex).value === 'number') {
                result = row.getCell(columnIndex)
              } else {
                result = Number(
                  getCellValue(row.getCell(columnIndex))
                    ?.toString()
                    ?.trim()
                    .replaceAll('.', '')
                    ?.replace(',', '.'),
                )
              }
            } else {
              if (typeof row.getCell(columnIndex).value === 'number') {
                result = Utils.roundNumber(
                  Number(getCellValue(row.getCell(columnIndex))),
                  formatNumber,
                )
              } else {
                result = Utils.roundNumber(
                  Number(
                    getCellValue(row.getCell(columnIndex))
                      ?.toString()
                      ?.trim()
                      .replaceAll('.', '')
                      ?.replace(',', '.'),
                  ),
                  formatNumber,
                )
              }
            }
            if (Number.isNaN(result)) {
              result = 0
            }
            return result
        }
      } else {
        return getCellValue(row.getCell(columnIndex))
      }
    } catch (error) {
      console.error(error)
      null
    }
  }

  const handleFile = async (file) => {
    const buffer = await file.arrayBuffer()

    const workbook = new ExcelJs.Workbook()
    await workbook.xlsx.load(buffer)

    const dataSheet = TYPE_INVOICE_EXCEL
    // 3️⃣ Validate data
    const dataValidate = {}
    let sttInvoiceNear
    let currencyInvoiceNear
    setShow(false)
    setValidateFile({ show: true })
    for (let index = 0; index < dataSheet.length; index++) {
      const arrayDataValidate = []
      let DATA_SHEET = dataSheet[index]
      const sheet = workbook.getWorksheet(DATA_SHEET?.label)
      if (!sheet) {
        dataValidate[DATA_SHEET?.value] = arrayDataValidate
      } else {
        // 1️⃣ Header ở dòng 12
        const HEADER_ROW = 12
        const DATA_START_ROW = 13

        const headerRow = sheet.getRow(HEADER_ROW)

        // 👉 headerMap: { headerName: columnIndex }
        const headerMap = {}

        headerRow.eachCell((cell, colNumber) => {
          const headerName = cell.value?.toString().trim().toLowerCase()
          if (!headerName) return
          headerMap[headerName] = colNumber
        })

        console.log('HEADER MAP:', headerMap)

        for (let i = DATA_START_ROW; i <= sheet.rowCount; i++) {
          const row = sheet.getRow(i)
          let stt = getCellByColumnName(
            row,
            headerMap['số thứ tự hóa đơn (*)'],
            null,
            'string',
          )
          let currency = getCellByColumnName(
            row,
            headerMap['loại tiền'],
            null,
            'string',
          )
          if (!stt) {
            stt = sttInvoiceNear
            currency = currencyInvoiceNear
          } else {
            sttInvoiceNear = stt
            currencyInvoiceNear = currency
          }
          const quantity = getCellByColumnName(
            row,
            headerMap['số lượng'],
            formatNumber?.quantity,
            'number',
          )
          const unitPrice = getCellByColumnName(
            row,
            headerMap['đơn giá'],
            !['VNĐ', 'VND'].includes(currency)
              ? formatNumber.currencyUnitPrice
              : formatNumber.unitPrice,
            'number',
          )

          const nameProduct = getCellByColumnName(
            row,
            headerMap['tên hàng hóa/dịch vụ (*)'],
            null,
            'string',
          )

          const discount = getCellByColumnName(
            row,
            headerMap['tiền ck'],
            !['VNĐ', 'VND'].includes(currency)
              ? formatNumber.foreignCurrency
              : formatNumber.currencyExchange,
            'number',
          )

          const totalselfnature = Utils.roundNumber(
            Number(unitPrice * quantity) - discount,
            !['VNĐ', 'VND'].includes(currency)
              ? formatNumber.foreignCurrency
              : formatNumber.currencyExchange,
          )

          const total = getCellByColumnName(
            row,
            headerMap['thành tiền(*)'],
            !['VNĐ', 'VND'].includes(currency)
              ? formatNumber.foreignCurrency
              : formatNumber.currencyExchange,
            'number',
          )

          const paymentMethod = getCellByColumnName(
            row,
            headerMap['hình thức thanh toán'],
            null,
            'string',
          )

          arrayDataValidate.push({
            stt,
            currency,
            quantity,
            unitPrice,
            totalselfnature,
            total,
            status:
              totalselfnature == total &&
              ((paymentMethod &&
                SelectOptions.paymentMethod.some(
                  (item) => item.label === paymentMethod,
                )) ||
                !paymentMethod),
            numericalOrder: i - DATA_START_ROW + 1,
            nameProduct,
            rowExcel: i,
            discount,
            paymentMethod,
          })
          dataValidate[DATA_SHEET?.value] = arrayDataValidate
          setValidateFile({ show: true, data: dataValidate })
        }
      }
      console.log('VALIDATE RESULT:', dataValidate)
    }
  }

  const handleDownloadSampleExcel = async () => {
    if (!selectedInvoiceTemplate) {
      alert('Lỗi khi tìm kiếm serial')
      return
    }

    const fileName = selectedInvoiceTemplate.name + '.xlsx'
    const extendFields = selectedInvoiceTemplate?.extend_fields || []
    const buyerInfoExtendFields = extendFields.filter(
      ({ regionName }) => regionName == 'buyerInfo',
    )
    const tableDetailExtendFields = extendFields.filter(
      ({ regionName }) => regionName == 'tableDetail',
    )
    const tableDetail1ExtendFields = extendFields.filter(
      ({ regionName }) => regionName == 'tableDetail1',
    )
    const commonFont = {
      name: 'Times New Roman',
      family: 4,
      size: 13,
    }
    const commonBorder = {
      top: { style: 'thin', color: { argb: '000000' } },
      left: { style: 'thin', color: { argb: '000000' } },
      bottom: { style: 'thin', color: { argb: '000000' } },
      right: { style: 'thin', color: { argb: '000000' } },
    }

    const wb = new ExcelJs.Workbook()
    // Đặt tên cột excel
    function getExcelColumnName(index) {
      let name = ''
      while (index >= 0) {
        name = String.fromCharCode((index % 26) + 65) + name
        index = Math.floor(index / 26) - 1
      }
      return name
    }
    function addWorkSheet({ invoiceTemplate, sheetName = 'Hóa đơn' }) {
      const ws = wb.addWorksheet(sheetName)

      /* gen excel columns */
      const isDeliveryTpl = Number(invoiceTemplate?.isDeliveryInvoice) === 1 // hoặc !!invoiceTemplate?.isDeliveryInvoice nếu là boolean

      let excelColumns = INVOICE_UPLOAD_HEADER_COLUMNS.filter(
        ({ onlyWeb, isDeliveryInvoice }) => {
          if (onlyWeb === true) return false

          // Cột chung (không ràng buộc loại hoá đơn) => luôn giữ
          if (isDeliveryInvoice == null) return true

          // Cột chỉ dành cho HĐ giao/nhận hàng đặc trưng
          const colIsDelivery = Number(isDeliveryInvoice) === 1
          return colIsDelivery === isDeliveryTpl
        },
      )

      /* add buyerInfo columns */
      let spi = excelColumns.findIndex(({ key }) => key == 'tenhanghoadichvu')
      excelColumns.splice(
        spi,
        0,
        ...buyerInfoExtendFields.map(({ label, name }) => ({
          header: label,
          key: name,
          width: 20,
          webWidth: '100px',
          description: label,
          mappingKeywords: label,
        })),
      )

      /* add tableDetail columns */
      excelColumns = excelColumns.concat(
        (invoiceTemplate?.category?.taxType == 2
          ? tableDetail1ExtendFields
          : tableDetailExtendFields
        ).map(({ label, name }) => ({
          header: label,
          key: name,
          width: 20,
          webWidth: '100px',
          description: label,
          mappingKeywords: label,
        })),
      )

      /* filter columns base on invoice template */
      excelColumns = filterColumnsBaseOnInvoiceTemplate({
        baseColumns: excelColumns,
        serial: invoiceTemplate,
      })

      let columnsLength = excelColumns.length

      // uploadGuides
      ws.mergeCells(`A1:${getExcelColumnName(columnsLength - 1)}1`)
      ws.getCell('A1').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: '99CCFF' },
      }
      ws.getCell('A1').value = INVOICE_UPLOAD_GUIDES.title
      ws.getCell('A1').font = {
        ...commonFont,
        size: 16,
        bold: true,
      }

      ws.mergeCells(`A2:${getExcelColumnName(columnsLength - 1)}2`)
      ws.getCell('A2').fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFCC99' },
      }
      ws.getCell('A2').value = INVOICE_UPLOAD_GUIDES.subtitle
      ws.getCell('A2').font = {
        ...commonFont,
        color: { argb: 'FF0000' },
      }

      let startIndex = 3
      INVOICE_UPLOAD_GUIDES.guides.forEach((guide) => {
        ws.mergeCells(
          `A${startIndex}:${getExcelColumnName(
            columnsLength - 1,
          )}${startIndex}`,
        )
        ws.getCell(`A${startIndex}`).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: 'FFCC99' },
        }
        ws.getCell(`A${startIndex}`).value = guide
        ws.getCell(`A${startIndex}`).font = {
          ...commonFont,
        }
        startIndex++
      })

      // sampleData
      /* header */
      startIndex = 12
      ws.getRow(startIndex).font = {
        ...commonFont,
        bold: true,
      }
      ws.getRow(startIndex).values = excelColumns.map(({ header }) => header)

      let startProductIndex = ws
        .getRow(startIndex)
        .values.findIndex((item) => item == 'Tên hàng hóa/dịch vụ (*)')

      excelColumns.forEach((_, index) => {
        // let cellName = `${ALPHABET_CHARACTERS[index]}${startIndex}`
        let cellName = `${getExcelColumnName(index)}${startIndex}`
        ws.getCell(cellName).border = commonBorder
        ws.getCell(cellName).fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {
            argb: index < startProductIndex - 1 ? 'CCCCFF' : 'FFFF00',
          },
        }
        ws.getCell(cellName).alignment = {
          vertical: 'middle',
          horizontal: 'center',
          wrapText: true,
        }
      })
      ws.columns = excelColumns.map(({ key, width }) => {
        return { key, width }
      })

      let INVOICE_UPLOAD_DATA_SAMPLES =
        invoiceTemplate.category.taxType == 1
          ? INVOICE_UPLOAD_DATA_SINGLE_TAX_RATE_SAMPLES()
          : INVOICE_UPLOAD_DATA_MULTIPLE_TAX_RATE_SAMPLES()
      /* add extentField sample data */
      INVOICE_UPLOAD_DATA_SAMPLES = INVOICE_UPLOAD_DATA_SAMPLES.map((item) => ({
        ...item,
        ...(item.stt ? buyerInfoExtendFields : []).reduce(
          (result, { name, defaultValue }) => ({
            ...result,
            [name]: defaultValue ?? '',
          }),
          {},
        ),
        ...(invoiceTemplate?.category?.taxType == 2
          ? tableDetail1ExtendFields
          : tableDetailExtendFields
        ).reduce(
          (result, { name, defaultValue }) => ({
            ...result,
            [name]: defaultValue ?? '',
          }),
          {},
        ),
      }))

      /* data */
      startIndex = 13
      ws.addRows(INVOICE_UPLOAD_DATA_SAMPLES)
      ws.eachRow((row, rowNumber) => {
        if (rowNumber < startIndex) return

        row.eachCell((cell) => {
          cell.alignment = {
            vertical: 'middle',
            horizontal: 'center',
            wrapText: true,
          }
          cell.border = commonBorder
          cell.font = commonFont
          if (cell._column?.key != 'thanhtienhh') {
            cell.numFmt = '@'
          }
        })
      })
    }

    if (selectedInvoiceTemplate.category.taxType == 3) {
      addWorkSheet({
        invoiceTemplate: {
          ...selectedInvoiceTemplate,
          category: { ...selectedInvoiceTemplate.category, taxType: 1 },
        },
        sheetName: 'HĐ một thuế suất',
      })
      addWorkSheet({
        invoiceTemplate: {
          ...selectedInvoiceTemplate,
          category: { ...selectedInvoiceTemplate.category, taxType: 2 },
        },
        sheetName: 'HĐ nhiều thuế suất',
      })
    } else {
      addWorkSheet({ invoiceTemplate: selectedInvoiceTemplate })
    }

    await wb.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const url = window.URL.createObjectURL(blob)
      const anchor = document.createElement('a')
      anchor.href = url
      anchor.download = fileName
      anchor.click()
      window.URL.revokeObjectURL(url)
    })
  }

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="ModalUploadInvoiceExcel"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <span>Upload excel hóa đơn</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div /* className="create-invoice-right-col" */>
            <div className="d-flex flex-row align-items-center w-100 mb-5">
              <FormLabel style={{ flexBasis: '80px' }} className="mb-1">
                Ký hiệu:
              </FormLabel>

              <CustomSelect
                classNamePrefix="rs-kh"
                placeholder={'Chọn ký hiệu'}
                currentValue={selectedInvoiceTemplate?.value}
                autoSize
                selectOptions={
                  templateInvoiceSerials?.map((item) => ({
                    invoiceTemplateId: item.invoiceTemplateId,
                    label: item.serial,
                    value: item.invoiceTemplateId,
                    name: item.name,
                    category: item.category,
                    extend_fields: item.extend_fields,
                    isDeliveryInvoice: item.isDeliveryInvoice,
                  })) ?? []
                }
                customFilterFn={(option, searchText) => {
                  return (
                    option.label
                      ?.toLowerCase()
                      ?.includes(searchText.toLowerCase()) ||
                    option.data.name
                      ?.toLowerCase()
                      ?.includes(searchText.toLowerCase())
                  )
                }}
                onChange={(selectedOption) =>
                  handleSelectInvoiceSerial(selectedOption)
                }
                components={{
                  MenuList,

                  Option,
                }}
                menuParentRef={document.querySelector(
                  '.ModalUploadInvoiceExcel',
                )}
              />
            </div>

            <div className="d-flex flex-row align-items-center w-100 mb-5">
              <FormLabel style={{ flexBasis: '80px' }} className="mb-1">
                Chọn file:
              </FormLabel>

              <div className="d-flex flex-fill align-items-center gap-2">
                {/* input file ẩn */}
                <input
                  id="real-file-input"
                  type="file"
                  className="d-none"
                  accept=".xlsx"
                  onChange={(e) => setSelectedFile(e.target.files?.[0] || null)}
                />

                {/* input giả */}
                <input
                  type="text"
                  className="form-control file-input-disabled"
                  readOnly
                  placeholder="Vui lòng chọn file"
                  value={selectedFile?.name || ''}
                  onClick={() =>
                    document.getElementById('real-file-input').click()
                  }
                  disabled
                />

                {/* nút Browse */}
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() =>
                    document.getElementById('real-file-input').click()
                  }
                  style={{ width: 120 }}
                >
                  Chọn file
                </button>
              </div>
            </div>

            {resultText && <UploadInvoiceNotifi text={resultText} />}
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="">
            <button
              className="btn btn-outline-warning mr-4"
              onClick={handleDownloadSampleExcel}
              disabled={!selectedInvoiceTemplate}
            >
              Tải file excel mẫu
            </button>

            <button
              className="btn btn-success px-8 mr-4"
              onClick={() => {
                handleUploadExcel({
                  notValidate:
                    window.location.pathname !=
                    '/hoa-don-dau-ra/hoa-don/danh-sach-hoa-don',
                })
              }}
              disabled={!selectedInvoiceTemplate || !selectedFile}
            >
              Tải lên
            </button>

            <button
              className="btn btn-outline-secondary px-8"
              onClick={handleClose}
            >
              Đóng
            </button>
          </div>
        </Modal.Footer>
      </Modal>
      <ModalValidateUploadInvoiceExcel
        validateFileData={validateFile.data}
        show={validateFile?.show}
        onHide={() => {
          setValidateFile({ ...validateFile, show: false })
          setShow(true)
        }}
        submit={() => {
          setValidateFile({ ...validateFile, show: false })
          handleUploadExcel({ notValidate: 1 })
          setShow(true)
        }}
      />
    </>
  )
}

function UploadInvoiceNotifi({ text }) {
  return (
    <div className="uin-container mt-5">
      <div className="uin-wrapper d-flex flex-row align-items-center">
        <i
          className="fa-sharp fa-2x fa-light fa-circle-info mr-2"
          style={{ color: '#044868' }}
        ></i>

        <span
          className="uin-text"
          dangerouslySetInnerHTML={{ __html: text }}
        ></span>
      </div>
    </div>
  )
}

export default ModalUploadInvoiceExcel
